// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"bd9cdfb9","239":"ad40150f","453":"8701dc61","455":"22d4e1b1","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};